import * as actions from '@/domain/messages/actions';
import { messagesFactory } from '@/domain/messages/adapters';

export const reducer = {
  messages(state = messagesFactory([]), action) {
    switch (action.type) {
      case actions.getMessagesAction.success:
        return action.payload;
      default:
        return state;
    }
  },
};
